import React from "react";
import { Modal } from "semantic-ui-react";
import { LeaderboardTable } from "../LeaderboardTable";
import { Leaderboard } from "@/services/bedrock";

interface LeaderboardModalProps {
  open: boolean;
  onClose: () => void;
  board?: Leaderboard;
  adminView?: boolean;
}

type Props = LeaderboardModalProps;

const LeaderboardModalFC: React.FC<Props> = ({ open, onClose, board, adminView }) => {
  return (
    <Modal open={open} onClose={onClose} closeIcon>
      <Modal.Content>
        {board && (
          <LeaderboardTable
            adminView={adminView}
            title={board.title}
            entityType={board.entityType}
            perPage={10}
            paginated={true}
            defaultMetric={board.metric}
            defaultStartTimeKey={board.startTimeKey}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};

export const LeaderboardModal = LeaderboardModalFC;
